import * as React from 'react';
import useDashboardManagement from '../../../../../hooks/useDashboardManagement';
import { TableauDesktopOptions } from '../../../../../models/tableau';
import DashboardManager from './dashboardManager';

interface Props {
  clientId: number;
}

const AddDashboard = ({ clientId }: Props) => {
  const [loading, setLoading] = React.useState<boolean>(true);
  const [desktopOptions, setDesktopOptions] = React.useState<TableauDesktopOptions[]>([]);
  const { fetchAllDashboardsFromTableau } = useDashboardManagement();

  React.useEffect(() => {
    if (!loading) {
      setLoading(true);
    }
    fetchAllDashboardsFromTableau(clientId).then((tableauList) => {
      setDesktopOptions(tableauList);
      setLoading(false);
    });
  }, []);

  return (
    <DashboardManager clientId={clientId} isNewDashboard={true} loading={loading} desktopOptions={desktopOptions} />
  );
};
export default AddDashboard;
